import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class AssetTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "customer",
      sortDirection: "asc",
    };
    this.sortStringName = "customer";
    this.sortDirection = "asc";
  }

  componentDidMount() { }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };

  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  render() {
    const { assets } = this.props;

    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>
              Name{" "}
              {this.state.sortString == "name" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("name");
                  }}
                />
              )}
            </th>
            <th>
              Friendly Name{" "}
              {this.state.sortString == "friendlyName" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("friendlyName");
                  }}
                />
              )}
            </th>
            <th>
              Depot{" "}
              {this.state.sortString == "depot" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("depot");
                  }}
                />
              )}
            </th>
            <th>
              Tag1
              {this.state.sortString == "tag1" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("tag1");
                  }}
                />
              )}
            </th>
            <th>
              Tag2
              {this.state.sortString == "tag2" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("tag2");
                  }}
                />
              )}
            </th>
            <th>
              Customer
              {this.state.sortString == "customer" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("customer");
                  }}
                />
              )}
            </th>
            <th>Profile</th>
            <th>Features</th>
            <th>
              Status
              {this.state.sortString == "status" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("status");
                  }}
                />
              )}
            </th>
            <th>
              Updated
              {this.state.sortString == "updated" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                    ? "fa-sort-amount-asc"
                    : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("updated");
                  }}
                />
              )}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {assets.map((asset, index) => {
            return (
              <tr key={asset.id}>
                <td>{asset.name}</td>
                <td>{asset.friendlyName}</td>
                <td>{asset.depotName}</td>
                <td>{asset.tag1}</td>
                <td>{asset.tag2}</td>
                <a
                  onClick={() =>
                    localStorage.setItem(
                      "customer",
                      JSON.stringify({
                        customerId: asset.customerId,
                        customerName: asset.customerName,
                      })
                    )
                  }
                  href={`/assets?customerId=${asset.customerId}&customerName=${asset.customerName}`}
                >
                  <td>{asset.customerName}</td>
                </a>

                <td>{asset.profile}</td>
                <td>
                  <div className="featureContainer">
                    {asset.speakerandMic ? (
                      <div className="featureContent">
                        <i class="fa fa-microphone"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.sosDuress ? (
                      <div className="featureContent">
                        <i class="fa fa-life-saver"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.tempA ? (
                      <div className="featureContent">
                        <i class="fa fa-thermometer-full"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.tempB ? (
                      <div className="featureContent">
                        <i class="fa fa-thermometer-quarter"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.harshEvents ? (
                      <div className="featureContent">
                        <i class="fa fa-bolt"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.driverID ? (
                      <div className="featureContent">
                        <i class="fa fa-id-card-o"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {asset.dashCamera ? (
                      <div className="featureContent">
                        <i class="fa fa-video-camera"></i>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </td>
                <td>{asset.status}</td>
                <td>{utcToLocal(asset.dbUpdated)}</td>
                <td>
                  <Link to={`/editAsset/${asset.id}`}>Edit</Link> |{" "}
                  <Link to={`/assetDetail/${asset.id}`}>Details</Link> |{" "}
                  <Link to={`/liveAlert/${asset.id}`}>Live Alert</Link>
                  {localStorage.getItem('role') === "SystemAdmin" ? (<span> | <Link to={`/deleteAsset/${asset.id}`}>Delete</Link> </span>) : ""}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default AssetTable;
